export default [
  {
    position: "absolute",
    top: 15,
    left: 50,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "recognitionP2.mTitleOne",
    mBody: "recognitionP2.mBodyOne",
    id: "SP_Recognition_Info_ColleagueSuccess",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 0.5,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "recognitionP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Recognition_Navigation_Menu",
    index: 1,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "recognitionP2.ttTextSeven",
    hover: false,
    id: "SP_Recognition_Navigation_Communications",
    index: 2,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "recognitionP2.ttTextTwo",
    hover: false,
    id: "SP_Recognition_Navigation_PayBenefits",
    index: 3,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "recognitionP2.ttTextThree",
    hover: false,
    id: "SP_Recognition_Navigation_Absence",
    index: 4,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 50.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "recognitionP2.ttTextFour",
    hover: false,
    id: "SP_Recognition_Navigation_Performance",
    index: 5,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "recognitionP2.ttTextFive",
    hover: false,
    id: "SP_Recognition_Navigation_Hiring",
    index: 6,
  },
  {
    position: "absolute",
    top: 2.8,
    left: 98.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "recognitionP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_Recognition_Navigation_TeamMember",
    index: 7,
  },
];
